import { useMemo } from 'react';
import { IVoucherDonor } from '@nkr/models/index';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, FirstDataRenderedEvent, ICellRendererParams } from 'ag-grid-community';
import styled from 'styled-components';
import { Glyphicon } from 'react-bootstrap';

const GridWrapper = styled.div`
    font-family: Roboto;

    height: 400px;
    width: 100%;

    .header {
        background-color: #ddd;
        font-weight: bold;
    }

    .header-center > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-cell {
        border-width: 0px 1px 1px 1px;
        border-style: solid;
        border-color: #ddd;
    }
`;

interface IProps {
    list: IVoucherDonor[],
    centerId: number
}

const VoucherDonors = (props: IProps) => {
    const columns: ColDef[] = [
        {
            headerName: 'Donor',
            headerClass: 'header',
            field: 'alias',
            width: 150,
            suppressSizeToFit: true,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IVoucherDonor;

                return (
                    <a href={`center/${props.centerId}/donor/${data.id}/profile/donor-data`} target='_blank'>{data.alias != '' ? data.alias : '[alias not specified]'}</a>
                );
            }
        },

        {
            headerName: 'Complete',
            headerClass: 'header header-center',
            field: 'isComplete',
            width: 110,
            suppressSizeToFit: true,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IVoucherDonor;

                if (data.isComplete) {
                    return <Glyphicon style={{ color: 'green' }} glyph='ok-sign' />;
                } else {
                    return <Glyphicon style={{ color: 'red' }} glyph='info-sign' />;
                }
            }
        },

        {
            headerName: 'Item',
            headerClass: 'header',
            field: 'donorStatus',
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IVoucherDonor;

                if (!data.isComplete) {
                    if (data.voucherHolders.length == 0) {
                        return (
                            <div>Donor: {data.donorStatus}</div>
                        );
                    } else {
                        return (
                            <div>
                                <div>Donor: {data.donorStatus}</div>
                                {data.voucherHolders.map(vh =>
                                    <div>{vh.status}</div>
                                )}
                            </div>
                        );
                    }
                } else {
                    return (
                        <div>All consent forms have been uploaded. Please verify accuracy and activate donor</div>
                    );
                }
            }
        }
    ];

    const columnDefs = useMemo(() => columns, []);
    const rowData = useMemo(() => props.list, [props.list]);

    return (
        <GridWrapper className='ag-theme-bootstrap'>
            <AgGridReact
                columnDefs={columnDefs}
                rowData={rowData}
                suppressCellSelection={true}
                suppressRowClickSelection={true}
                onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                getRowHeight={(e: any) => {
                    let data = e.data as IVoucherDonor;
                    let allHoldersComplete = data.voucherHolders.filter(x => x.isComplete).length == data.voucherHolders.length;

                    if (data.voucherHolders.length == 0 || allHoldersComplete) {
                        return 25;
                    } else {
                        return 25 + (data.voucherHolders.length * 25);
                    }
                }}
                getRowStyle={(e: any) => {
                    let isEven = ((e.node.rowIndex + 1) % 2) == 0;

                    if (isEven)
                        return { backgroundColor: '#f9f9f9' }

                    return null;
                }}
            />
        </GridWrapper>
    );
}

export default VoucherDonors;